import { AppActions, AppAsyncActions, AppState } from './app.types'

const actions = (state: AppActions) => state

const asyncActions = (state: AppAsyncActions) => state

const loading = (state: AppState) => state.status.loading

const locale = (state: AppState) => state.locale

const navExpanded = (state: AppState) => state.status.navExpanded

const status = (state: AppState) => state.status

const processes = (state: AppState) => state.processes

const message = (state: AppState) => state.message

const settings = (state: AppState) => state.settings

const user = (state: AppState) => state.auth.user

const auth = (state: AppState) => state.auth

const isLoggedIn = (state: AppState) => state.auth.isLoggedIn

const signIn = (state: AppAsyncActions) => state.signIn

const signUp = (state: AppAsyncActions) => state.signUp

export const appSelectors = {
  auth,
  loading,
  locale,
  navExpanded,
  processes,
  message,
  settings,
  status,
  user,
  isLoggedIn,

  actions,
  asyncActions,
  signIn,
  signUp,
}
